export const actions = {
    default: {
        move: {
            label: "Move",
        },
        snap_rotate_left: {
            label: "Snap Rotate Left",
        },
        snap_rotate_right: {
            label: "Snap Rotate Right",
        },
        action_mute: {
            label: "Mute",
        },
        action_teleport_down: {
            label: "Teleport Aim",
        },
        action_teleport_up: {
            label: "Teleport",
        },
        action_share_screen: {
            label: "Share Screen",
        },
        escape: {
            label: "Escape",
        },
    },
    hud: {
        action_ui_select_down: {
            label: "Select UI item",
        },
        action_ui_select_up: {
            label: "Select UI item",
        },
    },
};

export const mappings = {
    behaviours: {
        default: {
            "oculus-touch-controls": {
                joystick: "joystick_dpad4Xr",
                axisMoveWithDeadzone: "msft_mr_axis_with_deadzoneXr",
            },
            "vive-controls": {
                trackpad: "trackpad_dpad4",
                trackpad_scrolling: "trackpad_scrolling",
            },
            "windows-motion-controls": {
                joystick: "joystick_dpad4Xr",
                axisMoveWithDeadzone: "msft_mr_axis_with_deadzoneXr",
                trackpad: "trackpad_dpad4",
            },
            "generic-tracked-controller-controls": {
                joystick: "joystick_dpad4Xr",
                axisMoveWithDeadzone: "msft_mr_axis_with_deadzoneXr",
                trackpad: "trackpad_dpad4",
            },
            "daydream-controls": {
                trackpad: "trackpadday_dpad4",
            },
            "gearvr-controls": {
                trackpad: "trackpad_dpad4",
                trackpad_scrolling: "trackpad_scrolling",
            },
            "oculus-go-controls": {
                trackpad: "trackpad_dpad4",
            },
            "gamepad-controls": {
                joystick: "joystick_dpad4",
            },
        },
    },
    mappings: {
        default: {
            "vive-controls": {
                "trackpad.pressedmove": {
                    left: "move",
                },
                trackpad_dpad4_pressed_west_down: {
                    right: "snap_rotate_left",
                },
                trackpad_dpad4_pressed_east_down: {
                    right: "snap_rotate_right",
                },
                trackpad_dpad4_pressed_center_down: {
                    right: "action_primary_down",
                },
                trackpad_dpad4_pressed_north_down: {
                    right: "action_primary_down",
                },
                trackpad_dpad4_pressed_south_down: {
                    right: "action_primary_down",
                },
                trackpadup: {
                    right: "action_primary_up",
                },
                menudown: "menue",
                menuup: "thumb_up",
                gripdown: ["action_grab", "middle_ring_pinky_down"],
                gripup: ["action_release", "middle_ring_pinky_up"],
                trackpadtouchstart: "thumb_down",
                trackpadtouchend: "thumb_up",
                triggerdown: ["action_grab", "index_down"],
                triggerup: ["action_release", "index_up"],
                scroll: {
                    right: "move_duck",
                },
            },
            "oculus-touch-controls": {
                joystick_dpad4_west: {
                    right: "snap_rotate_left",
                },
                joystick_dpad4_east: {
                    right: "snap_rotate_right",
                },
                "trackpad.pressedmove": {
                    left: "move",
                },
                abuttontouchstart: "thumb_down",
                abuttontouchend: "thumb_up",
                bbuttontouchstart: "thumb_down",
                bbuttontouchend: "thumb_up",
                xbuttontouchstart: "thumb_down",
                xbuttontouchend: "thumb_up",
                ybuttontouchstart: "thumb_down",
                ybuttontouchend: "thumb_up",
                surfacetouchstart: "thumb_down",
                surfacetouchend: "thumb_up",
                thumbsticktouchstart: "thumb_down",
                thumbsticktouchend: "thumb_up",
                triggerdown: {
                    right: ["action_primary_down", "shoot_start"],
                    left: ["boost_down"],
                },
                triggerup: {
                    right: ["action_primary_up", "shoot_stop"],
                    left: ["boost_up"],
                },
                gripdown: ["primary_action_grab", "middle_ring_pinky_down"],
                gripup: ["primary_action_release", "middle_ring_pinky_up"],
                abuttondown: "action_teleport_start",
                abuttonup: "action_teleport_stop",
                xbuttondown: "jump_start",
                xbuttonup: "jump_stop",
                ybuttondown: "flyme",
                bbuttondown: "settingspanel",
                axisMoveWithDeadzone: {
                    left: "move",
                    right: "scroll_move",
                },
            },
            "windows-motion-controls": {
                joystick_dpad4_west: {
                    right: "snap_rotate_left",
                },
                joystick_dpad4_east: {
                    right: "snap_rotate_right",
                },
                "trackpad.pressedmove": {
                    left: "move",
                },
                joystick_dpad4_pressed_west_down: {
                    right: "snap_rotate_left",
                },
                joystick_dpad4_pressed_east_down: {
                    right: "snap_rotate_right",
                },
                thumbstick_dpad4_pressed_west_down: {
                    right: "snap_rotate_left",
                },
                thumbstick_dpad4_pressed_east_down: {
                    right: "snap_rotate_right",
                },
                trackpaddown: {
                    right: "action_primary_down",
                    left: "settingspanel",
                },
                trackpadup: {
                    right: "action_primary_up",
                },
                menudown: "menue",
                menuup: "menue",
                gripdown: [
                    "action_grab",
                    "middle_ring_pinky_down",
                    "action_click_down",
                ],
                gripup: [
                    "action_release",
                    "middle_ring_pinky_up",
                    "action_click_up",
                ],
                trackpadtouchstart: "thumb_down",
                trackpadtouchend: "thumb_up",
                triggerdown: {
                    left: ["action_grab", "index_down", "action_click_down"],
                    right: "shoot_start",
                },
                triggerup: {
                    left: ["action_release", "index_up", "action_click_up"],
                    right: "shoot_stop",
                },
                axisMoveWithDeadzone: {
                    left: "move",
                    right: "scroll_move",
                },
                trackpad_dpad4_pressed_center_down: {
                    left: "settingspanel",
                    right: "action_primary_down",
                },
                trackpad_dpad4_pressed_center_up: {
                    right: "action_primary_up",
                },
            },
            "daydream-controls": {
                trackpad_dpad4_pressed_west_down: "snap_rotate_left",
                trackpad_dpad4_pressed_east_down: "snap_rotate_right",
                trackpad_dpad4_pressed_center_down: ["action_primary_down"],
                trackpad_dpad4_pressed_north_down: ["shoot_start"],
                trackpad_dpad4_pressed_north_up: ["shoot_stop"],
                trackpad_dpad4_pressed_south_down: ["menue"],
                trackpadup: ["action_primary_up"],
                triggerdown: ["action_grab", "index_down", "action_click_down"],
                triggerup: ["action_release", "index_up", "action_click_up"],
                axisMoveWithDeadzone: {
                    right: "scroll",
                },
            },
            "gearvr-controls": {
                trackpad_dpad4_pressed_west_down: "snap_rotate_left",
                trackpad_dpad4_pressed_east_down: "snap_rotate_right",
                trackpad_dpad4_pressed_center_down: ["action_primary_down"],
                trackpad_dpad4_pressed_north_down: ["menue"],
                trackpad_dpad4_pressed_south_down: ["shoot"],
                trackpadup: ["action_primary_up"],
                triggerdown: ["action_primary_down"],
                triggerup: ["action_primary_up"],
                scroll: "move_duck",
            },
            "oculus-go-controls": {
                trackpad_dpad4_pressed_west_down: "snap_rotate_left",
                touchpad_dpad4_pressed_west_down: "snap_rotate_left",
                trackpad_dpad4_pressed_east_down: "snap_rotate_right",
                touchpad_dpad4_pressed_east_down: "snap_rotate_right",
                trackpad_dpad4_pressed_center_down: ["action_teleport_start"],
                trackpad_dpad4_pressed_center_up: ["action_teleport_stop"],
                trackpad_dpad4_pressed_south_down: ["menue"],
                touchpad_dpad4_pressed_south_down: ["menue"],
                triggerdown: [
                    "shoot_start",
                    "action_grab",
                    "action_primary_down",
                ],
                triggerup: [
                    "shoot_stop",
                    "action_release",
                    "action_primary_up",
                ],
            },
            "generic-tracked-controller-controls": {
                joystick_dpad4_west: {
                    right: "snap_rotate_left",
                },
                joystick_dpad4_east: {
                    right: "snap_rotate_right",
                },
                "trackpad.pressedmove": {
                    left: "move",
                },
                abuttontouchstart: "thumb_down",
                abuttontouchend: "thumb_up",
                bbuttontouchstart: "thumb_down",
                bbuttontouchend: "thumb_up",
                xbuttontouchstart: "thumb_down",
                xbuttontouchend: "thumb_up",
                ybuttontouchstart: "thumb_down",
                ybuttontouchend: "thumb_up",
                surfacetouchstart: "thumb_down",
                surfacetouchend: "thumb_up",
                thumbsticktouchstart: "thumb_down",
                thumbsticktouchend: "thumb_up",
                triggerdown: {
                    right: ["action_primary_down", "shoot_start"],
                    left: ["boost_down"],
                },
                triggerup: {
                    right: ["action_primary_up", "shoot_stop"],
                    left: ["boost_up"],
                },
                gripdown: ["primary_action_grab", "middle_ring_pinky_down"],
                gripup: ["primary_action_release", "middle_ring_pinky_up"],
                abuttondown: "action_teleport_start",
                abuttonup: "action_teleport_stop",
                bbuttondown: "settingspanel",
                axisMoveWithDeadzone: {
                    left: "move",
                    right: "scroll_move",
                },
            },
            "gamepad-controls": {
                "0down": "jump_start",
                "0up": "jump_stop",
                "5down": ["primary_action_grab", "middle_ring_pinky_down"],
                "5up": ["primary_action_release", "middle_ring_pinky_up"],
                "9down": "settingspanel",
                "10down": "boost_down",
                "10up": "boost_up",
                "6down": "boost_down",
                "6up": "boost_up",
                "2down": "shoot_start",
                "2up": "shoot_stop",
                "14down": "snap_rotate_left",
                "15down": "snap_rotate_right",
                "5down": ["primary_action_grab", "middle_ring_pinky_down"],
                "5up": ["primary_action_release", "middle_ring_pinky_up"],
                "7down": "action_primary_down",
                "7up": "primary_action_release",
                axisMoveWithDeadzone: "move",
            },
            keyboard: {
                keym_press: "action_mute",
                keyf_press: "shoot_start",
                keyf_up: "shoot_stop",
                keyt_press: "thirdview_toggle",
                keyw_down: "w_down",
                keyw_up: "w_up",
                keya_down: "a_down",
                keya_up: "a_up",
                keys_down: "s_down",
                keys_up: "s_up",
                keyd_down: "d_down",
                keyd_up: "d_up",
                arrowup_down: "w_down",
                arrowup_up: "w_up",
                arrowleft_down: "a_down",
                arrowleft_up: "a_up",
                arrowdown_down: "s_down",
                arrowdown_up: "s_up",
                arrowright_down: "d_down",
                arrowright_up: "d_up",
                keyr_down: "reposition",
                keyl_down: "lookatme",
                keyf_down: "flyme",
                tab_down: "settingspanel",
                shiftleft_down: "boost_down",
                shiftleft_up: "boost_up",
                shiftright_down: "boost_down",
                shiftright_up: "boost_up",
                space_down: "jump_start",
                space_up: "jump_stop",
                escape_down: "escape_down",
            },
        },
    },
};
